import '../comparison-table-v3.scss';

import * as Accordion from '@radix-ui/react-accordion';
import classNames from 'classnames';

import { DownIcon } from '../../../atoms';

interface Props {
  buttonText: string;
  children: React.ReactNode;
  onExpand?: () => void;
  onCollapse?: () => void;
}

export const SeeMoreFeaturesAccordion = ({ buttonText, children, onExpand, onCollapse }: Props) => {
  const handleValueChange = (value: string) => {
    if (value === 'open') {
      onExpand?.();
    } else {
      onCollapse?.();
    }
  };

  return (
    <Accordion.Root type="single" className="see-more-features-accordion" collapsible onValueChange={handleValueChange}>
      <Accordion.Item value="open">
        <Accordion.Trigger className="see-more-features-accordion-trigger">
          <span className="see-more-features-accordion-trigger-text">{buttonText}</span>
          <span className={classNames('caret', { 'caret-rotated': false })}>
            <DownIcon color="currentColor" />
          </span>
        </Accordion.Trigger>
        <Accordion.Content className="see-more-features-accordion-content">{children}</Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
